import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'preview-popup',
    templateUrl: 'preview-popup.component.html',
    styleUrls: ['./preview-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PreviewPopupComponent {
    announcement = '';
    parent: any;
    saveSiteNotificationParent: any;
    imageDataUrl: any;
    assetInfo = '';
    mediaType: string;
    previewUrl: string;
    pdfStoryBoardUrls: string[] = [];
    cuurentStoryBoardUrl: string;
    cuurentStoryBoardUrlIndex = 0;
}
